const BASE_PATH = process.env.REACT_APP_API_PATH;

export {
    BASE_PATH
}